// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'
import { string } from "yup";

const obj = {
  field: [
    {
      title: "Topic or Keyword",
      attr: "content",
      value: "",
      id: "topic",
      placeholder: "Topic",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string()
        .nullable()
        .trim("Initially whitespace are not allowed")
        .required("Topic or keyword is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
      let text || "Hello World"; 
      console.log(text);
      }`,
    },
  ],
  example: [
    {
      title: "Topic or Keyword",
      attr: "content",
      value: `Football`,
      id: "topic",
      placeholder: "topic",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string()
        .nullable()
        .trim("Initially whitespace are not allowed")
        .required("Topic or Keyword is Required "),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
      let text || "Hello World"; 
      console.log(text);
      }`,
    },
  ],

  editor: {
    output: `Semantic Cluster 1:\n- Indefinite\n- Unclear\n- Ambiguous\n- Vague \nSemantic Cluster 2:\n- Void\n- Incomplete\n- Unspecified\n- Unknown `,
  },
};

export default obj;
